import { render, staticRenderFns } from "./ChampCinemaHero.vue?vue&type=template&id=72409d7e"
import script from "./ChampCinemaHero.vue?vue&type=script&lang=js"
export * from "./ChampCinemaHero.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports